export default "__VITE_ASSET__DwMDz7wJ__"